import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLanguageList, updateLanguageList } from "../../../slices/panelSlice/languageSlice";
import {fetchOptionListData} from '../../../slices/LocationSlice/optionSlice'
import Pagination from '../../../components/Pagination';
import Loader from '../../../components/Loader';
import EditableTable from "./LanguageTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import { alertSuccess } from "../../../components/Alert";
import Swal from "sweetalert2";
import api from "../../../auth/api";



function Language({editable}) {
  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.language);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(data?.result) ? data?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(data?.result) ? Math.ceil(data?.result?.length / itemsPerPage) : 0;
  const headers = data?.result?.length > 0 ? Object.keys(data.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','status','code','val','optionType']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { optionList} = useSelector((state) => state.option);

  const addLanguage = ()=>{
    Swal.fire({
      title: "Add Language",
      html: `
        <input id="language-title" class="swal2-input" placeholder="Language Title">
        <input id="language-code" class="swal2-input" placeholder="Language Code">
        <input id="language-value" class="swal2-input" placeholder="Value">
        <select id="language-option-type" class="swal2-input border border-[#d9d9d9] focus:border-[#b1cae3] focus:[border-width:2px]  outline-none" ring-8 focus:ring>
        <option value="0" disabled >Select Option Type</option>
          ${optionList.result.map(
            (option) => `<option value="${option.id}">${option.title}</option>`
          ).join("")}
        </select>
      `,
      showCancelButton: true,
      confirmButtonText: "Add",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const title = document.getElementById("language-title").value.trim();
        const code = document.getElementById("language-code").value.trim();
        const value = document.getElementById("language-value").value.trim();
        const optionType = document.getElementById("language-option-type").value;
    
        // Validation for inputs
        if (!title) {
          Swal.showValidationMessage("Language title is required!");
          return;
        }
        if (title.length < 3) {
          Swal.showValidationMessage("Language title must be at least 3 characters long!");
          return;
        }
        if (!/^[a-zA-Z0-9\s]+$/.test(title)) {
          Swal.showValidationMessage("Language title can only contain letters, numbers, and spaces!");
          return;
        }
        if (!code) {
          Swal.showValidationMessage("Language code is required!");
          return;
        }
        if (!/^[a-zA-Z0-9]+$/.test(code)) {
          Swal.showValidationMessage("Language code can only contain letters and numbers!");
          return;
        }
        if (!value) {
          Swal.showValidationMessage("Value is required!");
          return;
        }
        if (!optionType) {
          Swal.showValidationMessage("Option type is required!");
          return;
        }
    
        try {
          const response = await api.post("/panel/languageList", {
            title,
            code,
            val:value,
            optionType,
            translate:{
              English:title
            }
          });
          alertSuccess("Language added successfully.");
          dispatch(fetchLanguageList());
        } catch (error) {
          console.error(error);
          Swal.showValidationMessage(
            error.response?.data?.errors || error.message
          );
        }
      },
      allowOutsideClick: false,
    });
    
    
  }
 

  useEffect(() => {
    dispatch(fetchLanguageList());
    dispatch(fetchOptionListData());
  }, [dispatch]);

  if (status === "loading") {
    return (
      <div className="pt-12">
        <Loader />
      </div>
    );
  }

  // if (status === "failed") {
  //   return <div>Error: {error}</div>;
  // }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = data.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    const { id, title,code,optionType,val} = editedData;
    const optionId = optionList?.result?.filter(f=>f.title===optionType)[0]?.id;
    const updatedData = { id, title, code, optionType:optionId,val };
    console.log(updatedData)
    const resp = await dispatch(updateLanguageList(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchLanguageList());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(['status','active'].includes(field)){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = data.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  return (
    <div className="w-full flex items-center flex-col">

        <div className="max-w-full">
        <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        optionList={optionList}
        languageList={data?.result}
        editable={editable}
      />
        </div>
     
      
      <div className="flex mt-4 items-center justify-between w-11/12">

<Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>

{editable && <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={addLanguage}>
      + Add Language
    </button>}


    </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />


    </div>
  );
}

export default Language;